import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

/**
 * Represents audio stream format used for custom audio input configurations.
 * @class AudioStreamFormat
 */
export var AudioStreamFormat = /*#__PURE__*/function () {
  function AudioStreamFormat() {
    _classCallCheck(this, AudioStreamFormat);
  }

  _createClass(AudioStreamFormat, null, [{
    key: "getDefaultInputFormat",

    /**
     * Creates an audio stream format object representing the default audio stream
     * format (16KHz 16bit mono PCM).
     * @member AudioStreamFormat.getDefaultInputFormat
     * @function
     * @public
     * @returns {AudioStreamFormat} The audio stream format being created.
     */
    value: function getDefaultInputFormat() {
      return AudioStreamFormatImpl.getDefaultInputFormat();
    }
    /**
     * Creates an audio stream format object with the specified pcm waveformat characteristics.
     * @member AudioStreamFormat.getWaveFormatPCM
     * @function
     * @public
     * @param {number} samplesPerSecond - Sample rate, in samples per second (Hertz).
     * @param {number} bitsPerSample - Bits per sample, typically 16.
     * @param {number} channels - Number of channels in the waveform-audio data. Monaural data
     *        uses one channel and stereo data uses two channels.
     * @returns {AudioStreamFormat} The audio stream format being created.
     */

  }, {
    key: "getWaveFormatPCM",
    value: function getWaveFormatPCM(samplesPerSecond, bitsPerSample, channels) {
      return new AudioStreamFormatImpl(samplesPerSecond, bitsPerSample, channels);
    }
  }]);

  return AudioStreamFormat;
}();
/**
 * @private
 * @class AudioStreamFormatImpl
 */
// tslint:disable-next-line:max-classes-per-file

export var AudioStreamFormatImpl = /*#__PURE__*/function (_AudioStreamFormat) {
  _inherits(AudioStreamFormatImpl, _AudioStreamFormat);

  var _super = _createSuper(AudioStreamFormatImpl);

  /**
   * Creates an instance with the given values.
   * @constructor
   * @param {number} samplesPerSec - Samples per second.
   * @param {number} bitsPerSample - Bits per sample.
   * @param {number} channels - Number of channels.
   */
  function AudioStreamFormatImpl() {
    var _this;

    var samplesPerSec = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16000;
    var bitsPerSample = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
    var channels = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    _classCallCheck(this, AudioStreamFormatImpl);

    _this = _super.call(this);
    _this.formatTag = 1;
    _this.bitsPerSample = bitsPerSample;
    _this.samplesPerSec = samplesPerSec;
    _this.channels = channels;
    _this.avgBytesPerSec = _this.samplesPerSec * _this.channels * (_this.bitsPerSample / 8);
    _this.blockAlign = _this.channels * Math.max(_this.bitsPerSample, 8);
    return _this;
  }
  /**
   * Retrieves the default input format.
   * @member AudioStreamFormatImpl.getDefaultInputFormat
   * @function
   * @public
   * @returns {AudioStreamFormatImpl} The default input format.
   */


  _createClass(AudioStreamFormatImpl, [{
    key: "close",

    /**
     * Closes the configuration object.
     * @member AudioStreamFormatImpl.prototype.close
     * @function
     * @public
     */
    value: function close() {
      return;
    }
  }], [{
    key: "getDefaultInputFormat",
    value: function getDefaultInputFormat() {
      return new AudioStreamFormatImpl();
    }
  }]);

  return AudioStreamFormatImpl;
}(AudioStreamFormat);